import {createRoot, hydrateRoot} from 'react-dom/client';
import Header from '../reusable_sections/Header'
import "../index.css";

type AnyProps = Record<string, any>;

let root:
| ReturnType<typeof createRoot>
    | ReturnType<typeof hydrateRoot>
        | null = null;

function mount(el: HTMLElement, props: AnyProps = {}) {
        console.log("Rendering......")
        root = createRoot(el);
        root.render(<Header {...(props as any)}/>);
    }

function hydrate(el: HTMLElement, props: AnyProps = {}) {
    console.log("Hydrating......")
    root = hydrateRoot(el, <Header {...(props as any)}/>);
}

function unmount() {
root?.unmount?.();
root = null;
}

if (typeof window !== 'undefined') (window as any).HeaderVC = {mount, hydrate, unmount}